import {Monitor, Layers, PenTool, Bot, Video, HelpCircle, Users, Smartphone} from 'lucide-react'
import { motion } from "framer-motion"

const resources = [
  { icon: Monitor, text: "Acesso completo à plataforma EW Pass" },
  { icon: Layers, text: "Aulas organizadas por nível" },
  { icon: PenTool, text: "Exercícios práticos" },
  { icon: Bot, text: "Lucy IA, nossa tutora 24 horas por WhatsApp" },
  { icon: Video, text: "Aulas ao vivo semanais" },
  { icon: HelpCircle, text: "Plantão com professores reais" },
  { icon: Users, text: "Comunidade ativa" },
  { icon: Smartphone, text: "App para estudar em qualquer lugar" },
]

function WhatYouGet() {
  return (
    <section className="bg-white py-14 sm:py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10"
        >
          Tudo que você precisa para sair do básico:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {resources.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-center gap-4 bg-gray-50 rounded-xl p-4 border border-gray-100 hover:border-blue-200 transition-colors"
            >
              <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center flex-shrink-0">
                <r.icon className="w-5 h-5 text-blue-600" />
              </div>
              <span className="text-gray-800 font-medium">{r.text}</span>
            </motion.div>
          ))}
        </div>

        {/* Value anchoring */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 sm:p-8 border border-blue-200"
        >
          <div className="space-y-3 text-center">
            <p className="text-gray-700">
              Quanto você gastaria em um curso tradicional ao mês: <span className="font-bold text-gray-900 line-through">R$ 350,00</span>
            </p>
            <p className="text-gray-700">
              E tem ainda as taxas de matrícula e material didático, em média <span className="font-bold text-gray-900 line-through">R$ 600</span> a cada seis meses
            </p>
            <p className="text-blue-700 font-bold text-lg mt-4">
              Aqui você investe menos do que muitas pessoas gastam em delivery em um fim de semana.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default WhatYouGet
